import React from 'react';
import {
  Box,
  Typography,
  Chip,
} from '@mui/material';
import BackButton from '../components/ui/BackButton';
import { useAuth } from '../context/AuthContext';
import SubstituteManagement from '../components/admin/SubstituteManagement';
import { StyledCard } from '../components/ui/StyledComponents';

function SubstituteManagementPage() {
  const { userRole } = useAuth();

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <BackButton to="/admin" label="Back to Dashboard" />
        <Typography variant="h4" component="h1">
          Substitute Teacher Management
          {userRole === 'super_admin' && (
            <Chip 
              label="Super Admin" 
              color="secondary" 
              size="small" 
              sx={{ ml: 2 }}
            />
          )}
        </Typography>
      </Box>

      <StyledCard>
        <SubstituteManagement />
      </StyledCard>
    </Box>
  );
}

export default SubstituteManagementPage;
